module.exports = __webpack_public_path__ + "static/media/surfingann-onder-de-vlinderboom-min.b07a5c45.png";